import '../../../../core/styles/focusRingStatic.css';
import '../../components/Alignment.css';
import '../../DataTable.css';
import '../ColumnSizing/ColumnSizing.css';
import '../../../../core/components/app-root/AppRoot.css';
import '../../components/DataTableVirtualizationContainer.css';
import '../RowInteractivity/RowInteractivity.css';
import '../Thresholds/Thresholds.css';
import '../RowOrder/RowOrder.css';
import '../RowDetails/RowDetails.css';
import '../../components/DataTableRow.css';
import '../../components/DataTableCell.css';
import '../ColumnOrder/ColumnOrder.css';
import '../../components/DataTableHeaderCell.css';
import '../../components/DataTableDefaultCell.css';
import './UserActions.css';
export var actionButton = '_duopj90-3-15-1 _z0fq9b4-3-15-1 _z0fq9bd-3-15-1 _z0fq9b6-3-15-1 _z0fq9b9-3-15-1';
export var floatingMenuButton = '_duopj91-3-15-1';